import React from "react";
import Tooltip from "@mui/material/Tooltip";
import * as Styles from "../../styles";

interface Props {
  temperaturaLead: string;
}

export const TemperaturaCell: React.FC<Props> = ({ temperaturaLead }) => (
  <Tooltip
    followCursor
    title={temperaturaLead || "--"}
    placement="top-start"
    arrow
  >
    <Styles.Td>{temperaturaLead || "--"}</Styles.Td>
  </Tooltip>
);
